var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{TaxIndexPdf:_vm.mode==='pdf',TaxIndex:_vm.mode==='default'}},[_c('div',{staticClass:"body-wrapper"},[_c('div',{staticClass:"desc"},[_c('p',[_vm._v(_vm._s(_vm.dataText))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }